/**
 * London Basket — nav dropdowns (matches Next.js NavDropdown)
 */
(function () {
  function updateHeaderOffset() {
    var header = document.querySelector(".lb-header");
    if (!header) return;
    document.documentElement.style.setProperty(
      "--lb-header-offset",
      header.offsetHeight + "px"
    );
  }

  function slugify(label) {
    return label.replace(/\s+/g, "-").toLowerCase();
  }

  function closeAll(except) {
    document.querySelectorAll(".lb-nav-dropdown").forEach(function (el) {
      if (el === except) return;
      el.classList.remove("is-open");
      var menu = el.querySelector(".lb-nav-menu");
      var backdrop = el.querySelector(".lb-nav-backdrop");
      if (menu) menu.style.display = "none";
      if (backdrop) backdrop.style.display = "none";
      var btn = el.querySelector(".lb-nav-link");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
  }

  function positionMenu(dropdown, menu) {
    var btn = dropdown.querySelector(".lb-nav-link");
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var top = rect.bottom + 6;
    var ribbon = document.getElementById("lb-live-shipping");
    if (ribbon && !ribbon.hidden) {
      var ribbonRect = ribbon.getBoundingClientRect();
      if (ribbonRect.height > 0) {
        top = Math.max(top, ribbonRect.bottom + 6);
      }
    }
    menu.style.top = top + "px";
    menu.style.left =
      Math.max(8, Math.min(rect.left, window.innerWidth - 280)) + "px";
  }

  document.querySelectorAll(".lb-nav-dropdown").forEach(function (dropdown) {
    var btn = dropdown.querySelector(".lb-nav-link");
    var menu = dropdown.querySelector(".lb-nav-menu");
    var backdrop = dropdown.querySelector(".lb-nav-backdrop");
    if (!btn || !menu) return;

    var menuId = "menu-" + slugify(dropdown.dataset.label || "menu");
    menu.id = menuId;

    if (backdrop) {
      backdrop.addEventListener("click", function () {
        closeAll(null);
      });
    }

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains("is-open");
      closeAll(dropdown);
      if (!isOpen) {
        dropdown.classList.add("is-open");
        positionMenu(dropdown, menu);
        menu.style.display = "block";
        if (backdrop) backdrop.style.display = "block";
        btn.setAttribute("aria-expanded", "true");
      }
    });

    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        closeAll(null);
      });
    });
  });

  document.addEventListener("pointerdown", function (e) {
    if (e.target.closest(".lb-nav-backdrop")) {
      closeAll(null);
      return;
    }
    if (e.target.closest(".lb-nav-menu")) return;
    if (e.target.closest(".lb-nav-dropdown .lb-nav-link")) return;
    closeAll(null);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll(null);
  });

  window.addEventListener(
    "scroll",
    function () {
      var nav = document.querySelector(".lb-main-nav");
      var header = document.querySelector(".lb-header");
      if (nav && header) {
        var headerBottom = header.getBoundingClientRect().bottom;
        if (nav.getBoundingClientRect().bottom < headerBottom + 4) {
          closeAll(null);
        }
      }
      document.querySelectorAll(".lb-nav-dropdown.is-open").forEach(function (dropdown) {
        var menu = dropdown.querySelector(".lb-nav-menu");
        if (menu) positionMenu(dropdown, menu);
      });
    },
    true
  );

  window.addEventListener("resize", function () {
    updateHeaderOffset();
    document.querySelectorAll(".lb-nav-dropdown.is-open").forEach(function (dropdown) {
      var menu = dropdown.querySelector(".lb-nav-menu");
      if (menu) positionMenu(dropdown, menu);
    });
  });

  updateHeaderOffset();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateHeaderOffset);
  }
  window.addEventListener("load", updateHeaderOffset);
})();
